// @flow
import {createSelector} from 'reselect'
import communicationLabels from '../../lib/data/communicationSettings'
import {COMMUNICATION_TYPE_NONE} from '../actions/preferences'


/**
 * Fetches the supported communication preferences from the store
 */
export const communicationPrefSelector = createSelector(
	(state) => state.Preferences.remoteCommunication,
	(remote) => {
		const values = {}

		for(let key of Object.keys(communicationLabels)){
			if(remote[key]){
				values[key] = remote[key]
			}
		}

		return values
	}
)

/**
 * Fetches supported communication preferences and gives a key, value of the selected preference
 */
export const communicationPrefValueSelector = createSelector(
	communicationPrefSelector,
	(preferences = {}) => {
		const prefVal = {}

		for(let [key, methods] of Object.entries(preferences)){
			let found = Object.entries(methods).find(e => e[1])
			prefVal[key] = found ? found[0] : COMMUNICATION_TYPE_NONE
		}

		return prefVal
	}
)



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/selectors/preferences.js